import { AxiosRequestConfig } from "axios";
import Repository from "@shared/services/api/abstracts/Repository";
import { UrlRouteMap } from "@shared/services/api/types";
import {
  UserBasedDiscountSerializer,
  UserBasedDiscountTicketInfoSerializer,
} from "../types";

export default class UserBasedDiscountRepository extends Repository<UserBasedDiscountTicketInfoSerializer> {
  public readonly repositoryName = "UserBasedDiscountRepository";

  public readonly endpoint = "/api/user/financials/discounts";

  public get urlMap(): UrlRouteMap {
    return {
      ...this.defaultUrlMap,
      credits: "credits",
      redeemGiftCard: "redeem-gift-card",
      cancelExchange: "cancel-exchange",
    };
  }

  public async credits(
    config: AxiosRequestConfig = {}
  ): Promise<UserBasedDiscountSerializer> {
    const { data } = await this.request<UserBasedDiscountSerializer>(
      this.buildUrl("credits"),
      config
    );

    return data;
  }

  public async redeemGiftCard(
    { redemption_code }: { redemption_code: string },
    config: AxiosRequestConfig = {}
  ): Promise<void> {
    const { data } = await this.request<void>(this.buildUrl("redeemGiftCard"), {
      method: "POST",
      data: { redemption_code },
      ...config,
    });

    return data;
  }

  public async cancelExchange(
    data?: { email: string },
    config: AxiosRequestConfig = {}
  ): Promise<UserBasedDiscountTicketInfoSerializer> {
    const { data: response } = await this.request(
      this.buildUrl("cancelExchange"),
      {
        data,
        method: "post",
        ...config,
      }
    );

    return response;
  }
}
